import { Box } from '@doist/marketist';
import { GetItAllDoneSequence } from 'components/product-ui/sequences/get-it-all-done-sequence/get-it-all-done-sequence';
import { QuickAddSequence } from 'components/product-ui/sequences/quick-add-sequence/quick-add-sequence';
import { SimplifyPlanningSequence } from 'components/product-ui/sequences/simplify-planning-sequence/simplify-planning-sequence';
import { TodayViewSequence } from 'components/product-ui/sequences/today-view-sequence/today-view-sequence';
export type Scene = 'quickAdd' | 'todayView' | 'getItDone' | 'simplifyPlanning';
type SceneContainerProps = {
  activeScene: Scene;
  className?: string;
};
export function SceneContainer({
  activeScene = 'quickAdd',
  className
}: SceneContainerProps) {
  return <Box className={className} data-sentry-element="Box" data-sentry-component="SceneContainer" data-sentry-source-file="scene-container.tsx">
            {activeScene === 'quickAdd' ? <QuickAddSequence /> : null}
            {activeScene === 'todayView' ? <TodayViewSequence /> : null}
            {activeScene === 'getItDone' ? <GetItAllDoneSequence /> : null}
            {activeScene === 'simplifyPlanning' ? <SimplifyPlanningSequence /> : null}
        </Box>;
}